var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1219_7160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.07996C10.033 2.08985 8.11298 2.68256 6.48267 3.7832C4.85235 4.88385 3.58485 6.44303 2.84031 8.26375C2.09578 10.0845 1.90762 12.085 2.2996 14.0126C2.69159 15.9402 3.64614 17.7084 5.04264 19.0937C6.43914 20.4791 8.21493 21.4194 10.1456 21.7959C12.0763 22.1724 14.0753 21.9681 15.89 21.209C17.7047 20.4499 19.2536 19.1699 20.3411 17.5308C21.4286 15.8917 22.0059 13.967 22 12C21.9789 9.36168 20.916 6.83864 19.0429 4.98055C17.1698 3.12245 14.6384 2.07987 12 2.07996ZM12.06 18C11.8147 18 11.575 17.9272 11.3711 17.791C11.1672 17.6547 11.0082 17.4611 10.9144 17.2345C10.8205 17.0079 10.796 16.7586 10.8438 16.518C10.8917 16.2775 11.0098 16.0566 11.1832 15.8831C11.3566 15.7097 11.5775 15.5916 11.8181 15.5438C12.0586 15.4959 12.3079 15.5205 12.5345 15.6143C12.7611 15.7082 12.9548 15.8671 13.091 16.071C13.2273 16.275 13.3 16.5147 13.3 16.76C13.3 17.0888 13.1694 17.4042 12.9368 17.6368C12.7043 17.8693 12.3889 18 12.06 18ZM12.06 13.35C11.8143 13.3499 11.5742 13.277 11.3701 13.1403C11.1659 13.0036 11.007 12.8093 10.9135 12.5821C10.8199 12.355 10.7959 12.1051 10.8446 11.8643C10.8933 11.6235 11.0124 11.4026 11.1868 11.2296C11.3612 11.0566 11.5831 10.9393 11.8243 10.8926C12.0655 10.8459 12.3151 10.8719 12.5415 10.9672C12.7679 11.0626 12.9609 11.2231 13.0959 11.4283C13.2309 11.6336 13.302 11.8743 13.3 12.12C13.3027 12.284 13.2725 12.4469 13.2113 12.5991C13.15 12.7513 13.0589 12.8898 12.9434 13.0062C12.8278 13.1227 12.6902 13.2149 12.5384 13.2774C12.3867 13.3398 12.2241 13.3713 12.06 13.37V13.35ZM12.06 8.70996C11.7311 8.70996 11.4157 8.57931 11.1832 8.34677C10.9506 8.11422 10.82 7.79882 10.82 7.46996C10.82 7.14109 10.9506 6.82569 11.1832 6.59314C11.4157 6.3606 11.7311 6.22996 12.06 6.22996C12.3889 6.22996 12.7043 6.3606 12.9368 6.59314C13.1694 6.82569 13.3 7.14109 13.3 7.46996C13.3 7.79882 13.1694 8.11422 12.9368 8.34677C12.7043 8.57931 12.3889 8.70996 12.06 8.70996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1219_7160",
    x: -1.89996,
    y: -1.92004,
    width: 27.9,
    height: 27.8999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1219_7160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1219_7160",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.5ff1e97e1da62321e511ad03b0abb059.svg";
export { ForwardRef as ReactComponent };